/**
 * Полоса прогресса в стиле загрузки файла в попапе проекта (см. EntityFilesPopoverServer).
 * Используется для фаз без XHR (подсчёт АЛ на клиенте): `percent === null` — неопределённая полоса.
 */
export type ProjectFilesClientWorkProgressProps = {
  headline: string;
  fileName: string;
  /** 0–100 или null — неопределённый прогресс */
  percent: number | null;
};

export function ProjectFilesClientWorkProgress({ headline, fileName, percent }: ProjectFilesClientWorkProgressProps) {
  const indeterminate = percent === null;
  const pctLabel = indeterminate ? '…' : `${Math.min(100, Math.max(0, Math.round(percent)))}%`;

  return (
    <div className="project-files-popover__uploading" role="status" aria-live="polite" aria-busy="true">
      <div className="project-files-popover__uploading-header">
        <div className="project-files-popover__uploading-name-col">
          <span className="project-files-popover__uploading-headline">{headline}</span>
          <span className="project-files-popover__uploading-filename" title={fileName}>
            {fileName}
          </span>
        </div>
        <span className="project-files-popover__uploading-pct">{pctLabel}</span>
      </div>
      <div className="project-files-popover__uploading-bar">
        <div
          className={
            indeterminate
              ? 'project-files-popover__uploading-bar-fill project-files-popover__uploading-bar-fill_indeterminate'
              : 'project-files-popover__uploading-bar-fill'
          }
          style={indeterminate ? undefined : { width: `${Math.min(100, Math.max(0, percent))}%` }}
        />
      </div>
    </div>
  );
}
